import React, { useState, useEffect } from 'react';
import { getUser } from '../../utils/auth';
import { Users, ShoppingBag, Shield, Settings, BarChart2, List, AlertTriangle } from 'lucide-react';
import UserManagement from './UserManagement';
import ServiceManagement from './ServiceManagement';
import PermissionManagement from './PermissionManagement';
import ServicePermissionConfig from './ServicePermissionConfig';
import DataStatistics from './DataStatistics';
import ZhantiTypeManagement from './ZhantiTypeManagement'; // Import the new component

const Yunying = () => {
  const [currentView, setCurrentView] = useState('dashboard');
  const user = getUser();

  useEffect(() => {
    if (!user?.is_admin) {
      window.location.href = '/';
    }
  }, [user]);

  if (!user?.is_admin) return null;

  const menuItems = [
    {
      id: 'users',
      title: '用户管理',
      desc: '查看用户列表、详情及订阅信息',
      icon: <Users className="w-8 h-8 text-indigo-600" />,
      color: 'bg-indigo-50 border-indigo-100',
      component: <UserManagement onBack={() => setCurrentView('dashboard')} />
    },
    {
      id: 'services',
      title: '服务管理',
      desc: '管理系统服务、价格及上下架状态',
      icon: <ShoppingBag className="w-8 h-8 text-purple-600" />,
      color: 'bg-purple-50 border-purple-100',
      component: <ServiceManagement onBack={() => setCurrentView('dashboard')} />
    },
    {
      id: 'permissions',
      title: '权限管理',
      desc: '定义系统权限点与功能控制',
      icon: <Shield className="w-8 h-8 text-blue-600" />,
      color: 'bg-blue-50 border-blue-100',
      component: <PermissionManagement onBack={() => setCurrentView('dashboard')} />
    },
   
    {
      id: 'config',
      title: '权限-服务配置管理',
      desc: '配置服务包含的权限集合',
      icon: <Settings className="w-8 h-8 text-gray-600" />,
      color: 'bg-gray-50 border-gray-100',
      component: <ServicePermissionConfig onBack={() => setCurrentView('dashboard')} />
    },
    {
      id: 'statistics',
      title: '数据统计',
      desc: '查看营收统计、订阅记录及趋势分析',
      icon: <BarChart2 className="w-8 h-8 text-green-600" />,
      color: 'bg-green-50 border-green-100',
      component: <DataStatistics onBack={() => setCurrentView('dashboard')} />
    },
    {
      id: 'zhanti_types',
      title: '占题类型管理',
      desc: '自定义六爻占卜的分类选项',
      icon: <List className="w-8 h-8 text-orange-600" />,
      color: 'bg-orange-50 border-orange-100',
      component: <ZhantiTypeManagement onBack={() => setCurrentView('dashboard')} /> // Add the new component here
    },
     {
      id: 'violation_management',
      title: '违规管理',
      desc: '管理用户违规行为及举报处理',
      icon: <AlertTriangle className="w-8 h-8 text-gray-600" />,
      color: 'bg-gray-50 border-gray-100',
      disabled: true,
      component: null
    }
  ];

  const renderContent = () => {
    if (currentView === 'dashboard') {
      return (
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">运营管理控制台</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {menuItems.map((item) => (
              <div
                key={item.id}
                onClick={() => !item.disabled && setCurrentView(item.id)}
                className={`
                  relative p-6 rounded-xl border transition-all duration-300
                  ${item.color}
                  ${item.disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:shadow-lg hover:-translate-y-1'}
                `}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="p-3 bg-white rounded-lg shadow-sm">
                    {item.icon}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      );
    }

    const activeItem = menuItems.find(item => item.id === currentView);
    return activeItem ? activeItem.component : null;
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      
      <div className="flex-grow p-4 md:p-8">
        {renderContent()}
      </div>

    
    </div>
  );
};

export default Yunying;